<template>
  <div class="d-flex">
    <div class="list-role-employee" v-if="isEmployee">
      <el-select
        v-model="currentRole"
        placeholder="Chọn"
        @change="changeRole(currentRole)"
        v-if="listEmployeeRoles.length > 1"
      >
        <el-option
          v-for="item in listEmployeeRoles"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </div>
    <Notification />
    <div
      style="margin-left: 15px;"
      class="notification-area"
      title="Đổi mặt khẩu"
      @click="changePass"
    >
      <i
        class="icon24-ChangePW"
      ></i>
    </div>
    <div
      v-if="MethodService.checkRole('AdminSystem')"
      style="margin-left: 15px;"
      class="login-as-area"
      title="Đăng nhập bằng"
      @click="loginAs"
    >
      <i class="fal fa-user-cog"></i>
    </div>
    <ModalLoginAs
      :dialogVisibleComnpanyProp="dialogVisibleComnpany"
      @closedialogVisibleComnpany="closedialogComnpany"
    />
  </div>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import MethodService from '../service/MethodService'
import RoleApi from '../moduleApi/RoleApi'
import ModalLoginAs from './components/ModalLoginAs'
import Notification from '../component/Notification'

export default {
  name: 'DefaultHeaderDropdownSetting',
  components: {
    AppHeaderDropdown,
    ModalLoginAs,
    Notification,
  },
  data: () => {
    return {
      MethodService,
      currentRole: '',
      listEmployeeRoleIds: [],
      listEmployeeRoles: [],
      isEmployee: false,
      currentUser: MethodService.getCurrentUser(),
      dialogVisibleComnpany: false,
    }
  },
  methods: {
    changePass(){
      this.$router.push({
        name: 'Auth-ChangePassword',
      })
    },
    async getListRole() {
      this.listEmployeeRoleIds = MethodService.getListEmployeeRoleIds()
      if (!this.listEmployeeRoleIds) return
      const roleApiRes = await RoleApi.list({
        filters: 'id:in:' + this.listEmployeeRoleIds.join(','),
        limit: this.listEmployeeRoleIds.length,
        fields: 'id,name'
      })
      this.isEmployee = true
      this.listEmployeeRoles = roleApiRes.result
      let currentRoleIdAtLocalStorage = localStorage.getItem('currentRoleId')
      let checkCurrentRoleIdAtLocalStorage = this.listEmployeeRoles.find(item => item.id == currentRoleIdAtLocalStorage)
      if (currentRoleIdAtLocalStorage && checkCurrentRoleIdAtLocalStorage) {
        this.currentRole = currentRoleIdAtLocalStorage
        localStorage.setItem('currentRoleName', checkCurrentRoleIdAtLocalStorage.name || '')
      } else {
        this.currentRole = this.listEmployeeRoleIds[0]
        localStorage.setItem('currentRoleId', this.listEmployeeRoleIds[0])
        const defaultRole = this.listEmployeeRoles.find(item => item.id == this.currentRole)
        localStorage.setItem('currentRoleName', defaultRole && defaultRole.name ? defaultRole.name : '')
      }
    },
    changeRole(roleId) {
      const selectedRole = this.listEmployeeRoles.find(item => item.id == roleId)
      localStorage.setItem('currentRoleId', roleId)
      localStorage.setItem('currentRoleName', selectedRole && selectedRole.name ? selectedRole.name : '')
      window.location.reload()
    },
    loginAs() {
      this.dialogVisibleComnpany = true
    },
    closedialogComnpany() {
      this.dialogVisibleComnpany = false
    }
  },
  created() {
    this.dialogVisibleComnpany = false
    this.getListRole()
  },
  mounted() {
  }
}
</script>
<style lang="scss" scoped>
.list-role-employee {
  max-width: 150px;
  margin-right: 15px;
}
.d-flex{
  display: flex;
  align-items: center;
}
.notification-area{
  height: 48px;
  width: 48px;
  background: #D0E8F5;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.notification-area i{
  color: #4F8AAB;
}

.login-as-area {
  height: 48px;
  width: 48px;
  background: #D0E8F5;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  i {
    color: #4F8AAB;
    &::before {
      font-size: 17px;
    }
  }
  &:hover {
    cursor: pointer;
  }
}
.notification-area:hover{
  cursor: pointer;
}
.change-pass:hover{
  cursor: pointer;
}
</style>
<style>
.el-popover__css{
  padding: 15px;
}
</style>
